var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSituationSacSansPerso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_7",
    "data-name": "Calque 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3000.5 3004.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-2,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-4,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-5,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#594b45;}.cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-2,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-4,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-5,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-6,.cls-68,.cls-69,.cls-7,.cls-71,.cls-72,.cls-73,.cls-74,.cls-8,.cls-9{stroke-miterlimit:10;}.cls-1{fill:url(#D\xE9grad\xE9_sans_nom_157);}.cls-2{fill:url(#D\xE9grad\xE9_sans_nom_157-2);}.cls-3{fill:url(#D\xE9grad\xE9_sans_nom_157-3);}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_157-4);}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_157-5);}.cls-6{fill:url(#D\xE9grad\xE9_sans_nom_157-6);}.cls-7{fill:url(#D\xE9grad\xE9_sans_nom_157-7);}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_157-8);}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_157-9);}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_157-10);}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_157-11);}.cls-12{fill:url(#D\xE9grad\xE9_sans_nom_157-12);}.cls-13{fill:url(#D\xE9grad\xE9_sans_nom_157-13);}.cls-14{fill:url(#D\xE9grad\xE9_sans_nom_157-14);}.cls-15{fill:url(#D\xE9grad\xE9_sans_nom_157-15);}.cls-16{fill:url(#D\xE9grad\xE9_sans_nom_157-16);}.cls-17{fill:url(#D\xE9grad\xE9_sans_nom_157-17);}.cls-18{fill:url(#D\xE9grad\xE9_sans_nom_157-18);}.cls-19{fill:url(#D\xE9grad\xE9_sans_nom_157-19);}.cls-20{fill:url(#D\xE9grad\xE9_sans_nom_157-20);}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_157-21);}.cls-22{fill:url(#D\xE9grad\xE9_sans_nom_157-22);}.cls-23{fill:url(#D\xE9grad\xE9_sans_nom_157-23);}.cls-24{fill:url(#D\xE9grad\xE9_sans_nom_157-24);}.cls-25{fill:url(#D\xE9grad\xE9_sans_nom_157-25);}.cls-26{fill:url(#D\xE9grad\xE9_sans_nom_157-26);}.cls-27{fill:url(#D\xE9grad\xE9_sans_nom_157-27);}.cls-28{fill:url(#D\xE9grad\xE9_sans_nom_157-28);}.cls-29{fill:url(#D\xE9grad\xE9_sans_nom_157-29);}.cls-30{fill:url(#D\xE9grad\xE9_sans_nom_157-30);}.cls-31{fill:url(#D\xE9grad\xE9_sans_nom_157-31);}.cls-32{fill:url(#D\xE9grad\xE9_sans_nom_157-32);}.cls-33{fill:url(#D\xE9grad\xE9_sans_nom_157-33);}.cls-34{fill:url(#D\xE9grad\xE9_sans_nom_157-34);}.cls-35{fill:url(#D\xE9grad\xE9_sans_nom_157-35);}.cls-36{fill:url(#D\xE9grad\xE9_sans_nom_157-36);}.cls-37{fill:url(#D\xE9grad\xE9_sans_nom_157-37);}.cls-38{fill:url(#D\xE9grad\xE9_sans_nom_157-38);}.cls-39{fill:url(#D\xE9grad\xE9_sans_nom_157-39);}.cls-40{fill:url(#D\xE9grad\xE9_sans_nom_157-40);}.cls-41{fill:url(#D\xE9grad\xE9_sans_nom_157-41);}.cls-42{fill:url(#D\xE9grad\xE9_sans_nom_157-42);}.cls-43{fill:url(#D\xE9grad\xE9_sans_nom_157-43);}.cls-44{fill:url(#D\xE9grad\xE9_sans_nom_157-44);}.cls-45{fill:url(#D\xE9grad\xE9_sans_nom_157-45);}.cls-46{fill:url(#D\xE9grad\xE9_sans_nom_157-46);}.cls-47{fill:url(#D\xE9grad\xE9_sans_nom_157-47);}.cls-48{fill:url(#D\xE9grad\xE9_sans_nom_157-48);}.cls-49{fill:url(#D\xE9grad\xE9_sans_nom_157-49);}.cls-50{fill:url(#D\xE9grad\xE9_sans_nom_157-50);}.cls-51{fill:url(#D\xE9grad\xE9_sans_nom_157-51);}.cls-52{fill:url(#D\xE9grad\xE9_sans_nom_157-52);}.cls-53{fill:url(#D\xE9grad\xE9_sans_nom_157-53);}.cls-54{fill:url(#D\xE9grad\xE9_sans_nom_157-54);}.cls-55{fill:url(#D\xE9grad\xE9_sans_nom_157-55);}.cls-56{fill:url(#D\xE9grad\xE9_sans_nom_157-56);}.cls-57{fill:url(#D\xE9grad\xE9_sans_nom_157-57);}.cls-58{fill:url(#D\xE9grad\xE9_sans_nom_157-58);}.cls-59{fill:url(#D\xE9grad\xE9_sans_nom_416);}.cls-60{fill:url(#D\xE9grad\xE9_sans_nom_92);}.cls-61{fill:#424242;opacity:0.42;}.cls-62{fill:#2a2a28;}.cls-63{fill:#f8b71f;}.cls-64{fill:#4c4e4d;}.cls-65{fill:#202120;}.cls-66{fill:#ffd02e;}.cls-67{fill:#1c1c1c;}.cls-68,.cls-69,.cls-71,.cls-72,.cls-73,.cls-74{fill:none;stroke:#b3b3ba;stroke-width:2px;}.cls-69{stroke-dasharray:6.14 2.05;}.cls-70{opacity:0.67;}.cls-71{stroke-dasharray:5.68 1.89;}.cls-72{stroke-dasharray:5.19 1.73;}.cls-73{stroke-dasharray:5.95 1.98;}.cls-74{stroke-dasharray:6.04 2.01;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157",
    x1: 1509.5,
    y1: 2874.85,
    x2: 1509.5,
    y2: 2831.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#614533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#a07860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a77d64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#b2866b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#c39376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#d19d7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#cf9b7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#c79678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ba8c70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#a77e65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#b1856b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#d19d7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#cf9c7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#c89678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#bd8d70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ac8065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966e57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b5a45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70513e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-2",
    x1: 709.5,
    y1: 2874.85,
    x2: 709.5,
    y2: 2831.8,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-3",
    x1: 2854.5,
    y1: 2874.85,
    x2: 2854.5,
    y2: 2831.8,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-4",
    x1: 2309.5,
    y1: 2874.85,
    x2: 2309.5,
    y2: 2831.8,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-5",
    x1: 1937.5,
    y1: 2830.8,
    x2: 1937.5,
    y2: 2787.75,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-6",
    x1: 1137.5,
    y1: 2830.8,
    x2: 1137.5,
    y2: 2787.75,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-7",
    x1: 369,
    y1: 2830.8,
    x2: 369,
    y2: 2787.75,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-8",
    x1: 2668.5,
    y1: 2830.8,
    x2: 2668.5,
    y2: 2787.75,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-9",
    x1: 2070.26,
    y1: 2787.75,
    x2: 2070.26,
    y2: 2744.7,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-10",
    x1: 1369.9,
    y1: 2787.75,
    x2: 1369.9,
    y2: 2744.7,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-11",
    x1: 697.11,
    y1: 2787.75,
    x2: 697.11,
    y2: 2744.7,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-12",
    x1: 187.56,
    y1: 2787.75,
    x2: 187.56,
    y2: 2744.7,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-13",
    x1: 2710.22,
    y1: 2787.75,
    x2: 2710.22,
    y2: 2744.7,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-14",
    x1: 155,
    y1: 2874.85,
    x2: 155,
    y2: 2831.8,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-15",
    x1: 1137.5,
    y1: 2917.9,
    x2: 1137.5,
    y2: 2874.85,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-16",
    x1: 1937.5,
    y1: 2917.9,
    x2: 1937.5,
    y2: 2874.85,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-17",
    x1: 369,
    y1: 2917.9,
    x2: 369,
    y2: 2874.85,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-18",
    x1: 187.5,
    y1: 2960.95,
    x2: 187.5,
    y2: 2917.9,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-19",
    x1: 773.5,
    y1: 2960.95,
    x2: 773.5,
    y2: 2917.9,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-20",
    x1: 1573.5,
    y1: 2960.95,
    x2: 1573.5,
    y2: 2917.9,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-21",
    x1: 2373.5,
    y1: 2960.95,
    x2: 2373.5,
    y2: 2917.9,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-22",
    x1: 2668.5,
    y1: 2917.9,
    x2: 2668.5,
    y2: 2874.85,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-23",
    x1: 405.5,
    y1: 3004,
    x2: 405.5,
    y2: 2960.95,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-24",
    x1: 1209.5,
    y1: 3004,
    x2: 1209.5,
    y2: 2960.95,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-25",
    x1: 2009.5,
    y1: 3004,
    x2: 2009.5,
    y2: 2960.95,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-26",
    x1: 2704.5,
    y1: 3004,
    x2: 2704.5,
    y2: 2960.95,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-27",
    x1: 2886.5,
    y1: 2960.95,
    x2: 2886.5,
    y2: 2917.9,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-28",
    x1: 1509.5,
    y1: 2615.55,
    x2: 1509.5,
    y2: 2572.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-29",
    x1: 709.5,
    y1: 2615.55,
    x2: 709.5,
    y2: 2572.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-30",
    x1: 2854.5,
    y1: 2615.55,
    x2: 2854.5,
    y2: 2572.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-31",
    x1: 2309.5,
    y1: 2615.55,
    x2: 2309.5,
    y2: 2572.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-32",
    x1: 1937.5,
    y1: 2571.5,
    x2: 1937.5,
    y2: 2528.45,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-33",
    x1: 1137.5,
    y1: 2571.5,
    x2: 1137.5,
    y2: 2528.45,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-34",
    x1: 369,
    y1: 2571.5,
    x2: 369,
    y2: 2528.45,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-35",
    x1: 2668.5,
    y1: 2571.5,
    x2: 2668.5,
    y2: 2528.45,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-36",
    x1: 2070.26,
    y1: 2528.45,
    x2: 2070.26,
    y2: 2485.4,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-37",
    x1: 1369.9,
    y1: 2528.45,
    x2: 1369.9,
    y2: 2485.4,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-38",
    x1: 697.11,
    y1: 2528.45,
    x2: 697.11,
    y2: 2485.4,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-39",
    x1: 187.56,
    y1: 2528.45,
    x2: 187.56,
    y2: 2485.4,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-40",
    x1: 2710.22,
    y1: 2528.45,
    x2: 2710.22,
    y2: 2485.4,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-41",
    x1: 155,
    y1: 2615.55,
    x2: 155,
    y2: 2572.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-42",
    x1: 1137.5,
    y1: 2658.6,
    x2: 1137.5,
    y2: 2615.55,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-43",
    x1: 1937.5,
    y1: 2658.6,
    x2: 1937.5,
    y2: 2615.55,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-44",
    x1: 369,
    y1: 2658.6,
    x2: 369,
    y2: 2615.55,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-45",
    x1: 187.5,
    y1: 2701.65,
    x2: 187.5,
    y2: 2658.6,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-46",
    x1: 773.5,
    y1: 2701.65,
    x2: 773.5,
    y2: 2658.6,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-47",
    x1: 1573.5,
    y1: 2701.65,
    x2: 1573.5,
    y2: 2658.6,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-48",
    x1: 2373.5,
    y1: 2701.65,
    x2: 2373.5,
    y2: 2658.6,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-49",
    x1: 2668.5,
    y1: 2658.6,
    x2: 2668.5,
    y2: 2615.55,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-50",
    x1: 405.5,
    y1: 2744.7,
    x2: 405.5,
    y2: 2701.65,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-51",
    x1: 1209.5,
    y1: 2744.7,
    x2: 1209.5,
    y2: 2701.65,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-52",
    x1: 2009.5,
    y1: 2744.7,
    x2: 2009.5,
    y2: 2701.65,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-53",
    x1: 2704.5,
    y1: 2744.7,
    x2: 2704.5,
    y2: 2701.65,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-54",
    x1: 2886.5,
    y1: 2701.65,
    x2: 2886.5,
    y2: 2658.6,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-55",
    x1: 405.5,
    y1: 2485.4,
    x2: 405.5,
    y2: 2442.35,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-56",
    x1: 1209.5,
    y1: 2485.4,
    x2: 1209.5,
    y2: 2442.35,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-57",
    x1: 2009.5,
    y1: 2485.4,
    x2: 2009.5,
    y2: 2442.35,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-58",
    x1: 2704.5,
    y1: 2485.4,
    x2: 2704.5,
    y2: 2442.35,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_416",
    x1: 1500,
    x2: 1500,
    y2: 2440.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c4932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6b5943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#67553f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c4932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c4932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_92",
    x1: 1500,
    y1: 2442,
    x2: 1500,
    y2: 2356.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#aeaeae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#b6b6b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#b6b6b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d7d7d"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sans le personnage") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1109.5,
    y: 2831.8,
    width: 800,
    height: 43.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 309.5,
    y: 2831.8,
    width: 800,
    height: 43.05
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2709.5,
    y: 2831.8,
    width: 290,
    height: 43.05
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1909.5,
    y: 2831.8,
    width: 800,
    height: 43.05
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1537.5,
    y: 2787.75,
    width: 800,
    height: 43.05
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 737.5,
    y: 2787.75,
    width: 800,
    height: 43.05
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 0.5,
    y: 2787.75,
    width: 737,
    height: 43.05
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2337.5,
    y: 2787.75,
    width: 662,
    height: 43.05
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1720.08,
    y: 2744.7,
    width: 700.37,
    height: 43.05
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1019.71,
    y: 2744.7,
    width: 700.37,
    height: 43.05
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 374.5,
    y: 2744.7,
    width: 645.21,
    height: 43.05
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 0.5,
    y: 2744.7,
    width: 374.12,
    height: 43.05
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 2420.45,
    y: 2744.7,
    width: 579.55,
    height: 43.05
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 0.5,
    y: 2831.8,
    width: 309,
    height: 43.05
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 737.5,
    y: 2874.85,
    width: 800,
    height: 43.05
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 1537.5,
    y: 2874.85,
    width: 800,
    height: 43.05
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 0.5,
    y: 2874.85,
    width: 737,
    height: 43.05
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 0.5,
    y: 2917.9,
    width: 374,
    height: 43.05
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 373.5,
    y: 2917.9,
    width: 800,
    height: 43.05
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 1173.5,
    y: 2917.9,
    width: 800,
    height: 43.05
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1973.5,
    y: 2917.9,
    width: 800,
    height: 43.05
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 2337.5,
    y: 2874.85,
    width: 662,
    height: 43.05
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 0.5,
    y: 2960.95,
    width: 810,
    height: 43.05
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 809.5,
    y: 2960.95,
    width: 800,
    height: 43.05
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 1609.5,
    y: 2960.95,
    width: 800,
    height: 43.05
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 2409.5,
    y: 2960.95,
    width: 590,
    height: 43.05
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 2773.5,
    y: 2917.9,
    width: 226,
    height: 43.05
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 1109.5,
    y: 2572.5,
    width: 800,
    height: 43.05
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 309.5,
    y: 2572.5,
    width: 800,
    height: 43.05
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 2709.5,
    y: 2572.5,
    width: 290,
    height: 43.05
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 1909.5,
    y: 2572.5,
    width: 800,
    height: 43.05
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 1537.5,
    y: 2528.45,
    width: 800,
    height: 43.05
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 737.5,
    y: 2528.45,
    width: 800,
    height: 43.05
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 0.5,
    y: 2528.45,
    width: 737,
    height: 43.05
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 2337.5,
    y: 2528.45,
    width: 662,
    height: 43.05
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 1720.08,
    y: 2485.4,
    width: 700.37,
    height: 43.05
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 1019.71,
    y: 2485.4,
    width: 700.37,
    height: 43.05
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 374.5,
    y: 2485.4,
    width: 645.21,
    height: 43.05
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 0.5,
    y: 2485.4,
    width: 374.12,
    height: 43.05
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 2420.45,
    y: 2485.4,
    width: 579.55,
    height: 43.05
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 0.5,
    y: 2572.5,
    width: 309,
    height: 43.05
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 737.5,
    y: 2615.55,
    width: 800,
    height: 43.05
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 1537.5,
    y: 2615.55,
    width: 800,
    height: 43.05
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 0.5,
    y: 2615.55,
    width: 737,
    height: 43.05
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 0.5,
    y: 2658.6,
    width: 374,
    height: 43.05
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 373.5,
    y: 2658.6,
    width: 800,
    height: 43.05
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 1173.5,
    y: 2658.6,
    width: 800,
    height: 43.05
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1973.5,
    y: 2658.6,
    width: 800,
    height: 43.05
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 2337.5,
    y: 2615.55,
    width: 662,
    height: 43.05
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 0.5,
    y: 2701.65,
    width: 810,
    height: 43.05
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 809.5,
    y: 2701.65,
    width: 800,
    height: 43.05
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 1609.5,
    y: 2701.65,
    width: 800,
    height: 43.05
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 2409.5,
    y: 2701.65,
    width: 590,
    height: 43.05
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2773.5,
    y: 2658.6,
    width: 226,
    height: 43.05
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 0.5,
    y: 2442.35,
    width: 810,
    height: 43.05
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 809.5,
    y: 2442.35,
    width: 800,
    height: 43.05
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 1609.5,
    y: 2442.35,
    width: 800,
    height: 43.05
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 2409.5,
    y: 2442.35,
    width: 590,
    height: 43.05
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    width: 3000,
    height: 2440.95
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    y: 2356.67,
    width: 3000,
    height: 85.33
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M2608,2553l102.22-114.65S2722,2359,2700,2352c0-22-26-216-123-211S2608,2553,2608,2553Z",
    transform: "translate(0 4)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sac"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M2426.07,2558.57s-149.81,1.71-155.51,0-5.7-2.84-5.7-2.84-17.65-1.71-20.5-2.85-12-4-15.38-12-7.41-23.93-9.12-47.85c-11.39-16.52-20.5-62.66-21.64-72.35s-2.28-38.73.57-49.55a157.72,157.72,0,0,1,5.12-16.52s-1.7-8-.57-10.26,10.26-4,10.83-4,8.54-2.85,8.54-5.13,14.24-113.36,20.51-132.15,29.91-78,50.13-87.73c-4.56-15.38-13.11-56.39-8.55-70.06.57-2.28,3.42-2.28,8-2.28s47.28-8.54,47.28-8.54,7.4-1.14,9.11-2.28,8.23-3.75,12.53,2.28l23.93,47.84,40.44-.56Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M2426.07,2295l-134.43-.17s-1.86-28.23,11.39-38.17c6.83-5.13,17.09-6.26,28.48-6.26h94.56Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "2285.37 2530.68 2291.64 2298.84 2426.07 2298.84 2426.07 2530.68 2285.37 2530.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M2262,2526.67s14.24-240.38,18.22-254.05,18.23-27.91,26.21-29,55.25-6.84,74.05-8,45.69-3.26,45.69-3.26l-.21,7.09s-109.28,5.86-118.39,10.42-18.8,17.65-19.37,22.78-15.95,254.05-15.95,254.05Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M2233,2541.48s8.54-57.53,11.39-95.12,18.23-201.08,15.38-222.73h-4.56s-29.62,241.52-29.62,268.87C2225.56,2511.29,2233,2541.48,2233,2541.48Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M2320.69,2158.13h42.72s-4-63.8,0-79.18,9.68-51.27,9.11-56.4a10.56,10.56,0,0,1-2.27-1.7s14.24-13.68,55.82-12V1993.5s-27.91-1.71-52.41,6.84c-4,1.71-10.25,1.14-12.53,3.42s-4,8-10.82,17.65c-8.55,14.25-18.23,20.51-23.36,32.47S2320.12,2134.77,2320.69,2158.13Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 2383.35,
    y: 2312.51,
    width: 42.72,
    height: 28.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 2290.5,
    y: 2357.51,
    width: 135.57,
    height: 13.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M2308.16,2354.08s-.57-1.71-3.42-1.71-4.56,4-4.56,4h-4a5.3,5.3,0,0,1-1.7,3.41c-1.71,1.71,0,28.49,0,28.49s-.57,8,6.26,8,7.41-6.84,7.41-6.84-2.28-17.65-2.28-21.64c1.14-.57,2.28-3.42,2.28-3.42h7.4v-10.25Zm-7.41,39.87a4.56,4.56,0,1,1,4.56-4.56A4.56,4.56,0,0,1,2300.75,2394Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M2422.65,2229.33l-4.56-1.71s-10.25.57-10.82,1.71-4,3.42-2.85,5.13l1.14,1.13s-2.28,10.26-1.71,12.54,1.71,5.12,5.7,5.12,7.4-1.71,8-4-1.13-11.4-1.13-11.4h5.12a4.45,4.45,0,0,0,2.28-1.71C2424.36,2235,2422.65,2229.33,2422.65,2229.33ZM2410.4,2251c-2.67,0-4.84-1.27-4.84-2.84s2.17-2.85,4.84-2.85,4.85,1.27,4.85,2.85S2413.08,2251,2410.4,2251Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M2415.25,2076.67l-8.55-1.14-6.83,8h1.69s-6.25,9.12-6.82,10.26-.57,3.42,0,4,12.53-2.27,13.67-2.84,1.61-11.4,1.61-11.4h12.63v-2.27Zm-6.84,4.56,4-2.28,6.26,1.71,1.14.57Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2270.56,
    y1: 2163.83,
    x2: 2273.56,
    y2: 2163.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2275.61,
    y1: 2163.83,
    x2: 2422.04,
    y2: 2163.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2423.07,
    y1: 2163.83,
    x2: 2426.07,
    y2: 2163.83
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2322.4,
    y1: 2159.28,
    x2: 2325.4,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-71",
    x1: 2327.29,
    y1: 2159.28,
    x2: 2356.62,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2357.56,
    y1: 2159.28,
    x2: 2360.56,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2322.4,
    y1: 2130.8,
    x2: 2325.4,
    y2: 2130.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-71",
    x1: 2327.29,
    y1: 2130.8,
    x2: 2356.62,
    y2: 2130.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2357.56,
    y1: 2130.8,
    x2: 2360.56,
    y2: 2130.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2322.4,
    y1: 2130.8,
    x2: 2322.4,
    y2: 2133.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 2322.4,
    y1: 2135.53,
    x2: 2322.4,
    y2: 2155.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2322.4,
    y1: 2156.28,
    x2: 2322.4,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2360.56,
    y1: 2130.8,
    x2: 2360.56,
    y2: 2133.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 2360.56,
    y1: 2135.53,
    x2: 2360.56,
    y2: 2155.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2360.56,
    y1: 2156.28,
    x2: 2360.56,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2322.4,
    y1: 2130.8,
    x2: 2324.8,
    y2: 2132.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-73",
    x1: 2326.39,
    y1: 2133.78,
    x2: 2357.36,
    y2: 2156.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2358.16,
    y1: 2157.48,
    x2: 2360.56,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2360.56,
    y1: 2130.8,
    x2: 2358.16,
    y2: 2132.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-73",
    x1: 2356.57,
    y1: 2133.78,
    x2: 2325.6,
    y2: 2156.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2324.8,
    y1: 2157.48,
    x2: 2322.4,
    y2: 2159.28
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2270.56,
    y1: 2170.67,
    x2: 2273.56,
    y2: 2170.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2275.61,
    y1: 2170.67,
    x2: 2422.04,
    y2: 2170.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2423.07,
    y1: 2170.67,
    x2: 2426.07,
    y2: 2170.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M2241.51,2526.1a4.73,4.73,0,0,0,2.57,1.45",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M2246,2528.07c21.17,5,110.56,5.75,176,4.39",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M2423.07,2532.44l3-.07",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M2426.07,2558.57s149.81,1.71,155.51,0,5.69-2.84,5.69-2.84,17.66-1.71,20.51-2.85,12-4,15.38-12,7.41-23.93,9.11-47.85c11.4-16.52,20.51-62.66,21.65-72.35s2.28-38.73-.57-49.55a155.81,155.81,0,0,0-5.13-16.52s1.71-8,.57-10.26-10.25-4-10.82-4-8.54-2.85-8.54-5.13-14.24-113.36-20.51-132.15-29.91-78-50.13-87.73c4.56-15.38,13.1-56.39,8.55-70.06-.57-2.28-3.42-2.28-8-2.28s-47.28-8.54-47.28-8.54-7.4-1.14-9.11-2.28-8.23-3.75-12.53,2.28l-23.93,47.84-40.44-.56Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M2426.07,2295l134.43-.17s1.86-28.23-11.39-38.17c-6.84-5.13-17.09-6.26-28.48-6.26h-94.56Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "2566.77 2530.68 2560.5 2298.84 2426.07 2298.84 2426.07 2530.68 2566.77 2530.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M2590.12,2526.67s-14.24-240.38-18.23-254.05-18.22-27.91-26.2-29-55.25-6.84-74.05-8-45.69-3.26-45.69-3.26l.21,7.09s109.28,5.86,118.39,10.42,18.8,17.65,19.37,22.78,15.95,254.05,15.95,254.05Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M2619.17,2541.48s-8.54-57.53-11.39-95.12-18.23-201.08-15.38-222.73H2597s29.62,241.52,29.62,268.87C2626.58,2511.29,2619.17,2541.48,2619.17,2541.48Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M2531.45,2158.13h-42.72s4-63.8,0-79.18-9.69-51.27-9.12-56.4a10.75,10.75,0,0,0,2.28-1.7s-14.24-13.68-55.82-12V1993.5s27.91-1.71,52.4,6.84c4,1.71,10.26,1.14,12.54,3.42s4,8,10.82,17.65c8.54,14.25,18.23,20.51,23.35,32.47S2532,2134.77,2531.45,2158.13Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 2426.07,
    y: 2308.51,
    width: 42.72,
    height: 28.48,
    transform: "translate(4894.86 4649.5) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 2426.07,
    y: 2353.51,
    width: 135.57,
    height: 13.1,
    transform: "translate(4987.71 4724.12) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M2536.58,2354.08v10.25h7.4s1.14,2.85,2.28,3.42c0,4-2.28,21.64-2.28,21.64s.57,6.84,7.41,6.84,6.26-8,6.26-8,1.71-26.78,0-28.49a5.28,5.28,0,0,1-1.71-3.41h-4s-1.71-4-4.56-4-3.42,1.71-3.42,1.71Zm10.25,35.31a4.56,4.56,0,1,1,4.56,4.56A4.56,4.56,0,0,1,2546.83,2389.39Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M2428.35,2236.16a4.45,4.45,0,0,0,2.28,1.71h5.12s-1.71,9.12-1.14,11.4,4,4,8,4,5.12-2.84,5.69-5.12-1.7-12.54-1.7-12.54l1.13-1.13c1.14-1.71-2.27-4-2.84-5.13s-10.83-1.71-10.83-1.71l-4.55,1.71S2427.78,2235,2428.35,2236.16Zm8.54,12c0-1.58,2.17-2.85,4.84-2.85s4.85,1.27,4.85,2.85-2.17,2.84-4.85,2.84S2436.89,2249.7,2436.89,2248.13Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M2429.49,2081.23v2.27h12.63s.47,10.83,1.61,11.4,13.1,3.41,13.67,2.84.57-2.84,0-4-6.82-10.26-6.82-10.26h1.69l-6.83-8-8.55,1.14Zm2.84,0,1.14-.57,6.27-1.71,4,2.28Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2581.58,
    y1: 2163.83,
    x2: 2578.58,
    y2: 2163.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2576.53,
    y1: 2163.83,
    x2: 2430.09,
    y2: 2163.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2429.07,
    y1: 2163.83,
    x2: 2426.07,
    y2: 2163.83
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2529.74,
    y1: 2159.28,
    x2: 2526.74,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-71",
    x1: 2524.85,
    y1: 2159.28,
    x2: 2495.52,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2494.58,
    y1: 2159.28,
    x2: 2491.58,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2529.74,
    y1: 2130.8,
    x2: 2526.74,
    y2: 2130.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-71",
    x1: 2524.85,
    y1: 2130.8,
    x2: 2495.52,
    y2: 2130.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2494.58,
    y1: 2130.8,
    x2: 2491.58,
    y2: 2130.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2529.74,
    y1: 2130.8,
    x2: 2529.74,
    y2: 2133.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 2529.74,
    y1: 2135.53,
    x2: 2529.74,
    y2: 2155.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2529.74,
    y1: 2156.28,
    x2: 2529.74,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2491.58,
    y1: 2130.8,
    x2: 2491.58,
    y2: 2133.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 2491.58,
    y1: 2135.53,
    x2: 2491.58,
    y2: 2155.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2491.58,
    y1: 2156.28,
    x2: 2491.58,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2529.74,
    y1: 2130.8,
    x2: 2527.34,
    y2: 2132.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-73",
    x1: 2525.75,
    y1: 2133.78,
    x2: 2494.77,
    y2: 2156.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2493.98,
    y1: 2157.48,
    x2: 2491.58,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2491.58,
    y1: 2130.8,
    x2: 2493.98,
    y2: 2132.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-73",
    x1: 2495.57,
    y1: 2133.78,
    x2: 2526.54,
    y2: 2156.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2527.34,
    y1: 2157.48,
    x2: 2529.74,
    y2: 2159.28
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2581.58,
    y1: 2170.67,
    x2: 2578.58,
    y2: 2170.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2576.53,
    y1: 2170.67,
    x2: 2430.09,
    y2: 2170.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-68",
    x1: 2429.07,
    y1: 2170.67,
    x2: 2426.07,
    y2: 2170.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M2610.63,2526.1a4.72,4.72,0,0,1-2.58,1.45",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M2606.12,2528.07c-21.17,5-110.56,5.75-176,4.39",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M2429.06,2532.44l-3-.07",
    transform: "translate(0 4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSituationSacSansPerso);
export default __webpack_public_path__ + "static/media/situation_sac_sans_perso.4226d7321e4b6a2f7856e7b09e4f3f14.svg";
export { ForwardRef as ReactComponent };